export const CompanyRels = {
    getCompanies: 'getCompanies',
    getCompany: 'getCompany',
    updateCompany: 'updateCompany',
    getCompanyUsers: 'getCompanyUsers',
    createCompanyUser: 'createCompanyUser',
    getUsers: 'getUsers',
    deleteCompanyUser: 'deleteCompanyUser'
};
